import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCustomerAuth } from '../context/CustomerAuthContext';
import SEO from '../components/SEO';
import './CustomerAuth.css';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const { forgotPassword } = useCustomerAuth();

  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await forgotPassword(email);

    if (result.success) {
      setSent(true);
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="customer-auth-page">
      <SEO title={t('auth.forgotPassword', 'Forgot Password')} />

      <div className="auth-card">
        <div className="auth-header">
          <h1>{t('auth.resetPasswordTitle', 'Reset Password')}</h1>
          <p>{t('auth.resetPasswordSubtitle', "Enter your email and we'll send you a link to reset your password")}</p>
        </div>

        {error && <div className="auth-error-banner">{error}</div>}

        {sent ? (
          <div className="auth-success-state">
            <div className="auth-success-icon">&#10003;</div>
            <h2>{t('auth.emailSent', 'Check your email')}</h2>
            <p>{t('auth.emailSentMessage', "If an account exists with that email, we've sent a password reset link.")}</p>
            <Link to="/login" className="auth-submit-btn auth-submit-btn--link">
              {t('auth.backToLogin', 'Back to Login')}
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="auth-form-group">
              <label htmlFor="email">{t('checkout.email', 'Email')}</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="john@example.com"
                required
                autoFocus
              />
            </div>

            <button type="submit" className="auth-submit-btn" disabled={loading}>
              {loading ? t('auth.sending', 'Sending...') : t('auth.sendResetLink', 'Send Reset Link')}
            </button>
          </form>
        )}

        <div className="auth-links">
          <Link to="/login">{t('auth.backToLogin', 'Back to Login')}</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
